<template>
  <!-- Mobile Menu -->
  <div class="dropdown mobile-user-menu">
    <a
      href="javascript:void(0);"
      class="nav-link dropdown-toggle"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <i class="fa fa-ellipsis-v"></i>
    </a>

    <div class="dropdown-menu dropdown-menu-right">
      <!-- === LOCATION SELECTOR === -->
      <div v-if="hasMultipleLocations" class="dropdown-item p-2">
        <select
          v-model="currentLocationId"
          class="form-select form-select-sm"
          @change="onLocationChange"
        >
          <option v-for="loc in locations" :key="loc.id" :value="loc.id">
            {{ loc.name }}
          </option>
        </select>
      </div>

      <div v-else class="dropdown-item text-muted small p-2">
        Location: {{ getCurrentLocationName }}
      </div>

      <div class="dropdown-divider"></div>

      <!-- === LOGOUT === -->
      <a class="dropdown-item" @click.prevent="handleLogout" href="#">Logout</a>
    </div>
  </div>
  <!-- /Mobile Menu -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'MobileUserMenu',

  computed: {
    ...mapGetters([
      'getLocations',
      'hasMultipleLocations',
      'getCurrentLocationId',
      'getCurrentLocationName'
    ]),

    locations() {
      return this.getLocations;
    },

    currentLocationId: {
      get() {
        return this.getCurrentLocationId;
      },
      set(id) {}
    }
  },

  methods: {
    ...mapActions(['logout', 'setCurrentLocation']),

    onLocationChange(event) {
      const id = event.target.value;
      const loc = this.locations.find(l => l.id === id);
      if (loc) {
        this.setCurrentLocation({ id: loc.id, name: loc.name });
        // Page will reload from Vuex action
      }
    },

    async handleLogout() {
      try {
        await this.logout();
        this.$router.push({ name: 'signin' });
      } catch (err) {
        console.error('Logout failed:', err);
        this.$router.push({ name: 'signin' });
      }
    }
  }
};
</script>

<style scoped>
/* Make dropdown fit mobile */
.mobile-user-menu .dropdown-menu {
  min-width: 200px;
}
.form-select-sm {
  font-size: 0.875rem;
}
.dropdown-divider {
  margin: 0.25rem 0;
}
</style>